/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyUpgradeDetailsCto } from '../../models/company-upgrade-details-cto';

export interface GetCompanyUpgradeDetails$Plain$Params {
  companyId: string;
}

export function getCompanyUpgradeDetails$Plain(http: HttpClient, rootUrl: string, params: GetCompanyUpgradeDetails$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyUpgradeDetailsCto>>> {
  const rb = new RequestBuilder(rootUrl, getCompanyUpgradeDetails$Plain.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyUpgradeDetailsCto>>;
    })
  );
}

getCompanyUpgradeDetails$Plain.PATH = '/company/{companyId}/upgrade';
